<template>
    <div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->       
            <div class="col-md-7 fixed-top m-auto" v-if="mailSent!=null">
                <b-alert
                    :show="alert.dismissCountDown"
                    dismissible :variant="mailSent? 'success' : 'danger'"
                    @dismissed="[alert.dismissCountDown=0, mailSent=null]"
                    @dismiss-count-down="countDownChanged">
                    <div class="text-center m-auto pl-4" :class="mailSent? 'text-dark':'text-danger'"> <br>
                    <span  v-if="mailSent"  >  
                      <span class="lead">Nous avons envoyé le lien de création du mot de passe par e-mail à  :<br> {{_props.selected_user.email}} </span> 
                        <br> <hr>
                        <span >Si l'utilisateur ne reçoit pas un mail de notre part, cela signifie que son adresse mail est invalide.
                            <br> Dans ce cas, veuillez utiliser une adresse mail valide.</span>
                    </span>
                      <span v-else class="lead">Nous ne pouvons pas trouver un utilisateur avec cette adresse e-mail : <br> {{_props.selected_user.email}} </span>
                    <br><hr>
                    <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                    </div>
                </b-alert>
            </div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  

            <div v-if="_props.selected_user!=null" >
                 <div class="text-center mb-4">
                     <h5 class="font-weight-normal">{{_props.selected_user.title}} {{_props.selected_user.lastname}}  {{_props.selected_user.firstname}}</h5>
                </div>

                <div> 
                    <form @submit.prevent="appliquer(selected_user)">
                        <table class="table text-center font-weight-light table-borderless">
                            
                                <tr>
                                    <td class="align-middle">
                                        Adhérent(e) :
                                    </td>
                                    <td class="align-middle"> 
                                        <input class="align-middle mr-2 ml-2" type="radio" id="one" :value="true" v-model="role_adh.role"> <span  :for="true" class="align-middle mr-2"> Oui </span>
                                        <input class="align-middle mr-2 ml-2" type="radio" id="two" :value="false" v-model="role_adh.role"> <span :for="false" class=align-middle> Non </span>
                                    </td>

                                    <td  class="align-middle"> 
                                        Code de l'adhérent  :  <span v-show="role_adh.role"  class="text-danger font-weight-bold" >*</span>
                                    </td>
                                    <td class="align-middle">
                                        <input type="text" v-model="role_adh.code" class="form-control border-color not-allowed " 
                                            placeholder="Entrer le code adhérent"  
                                            :disabled="!role_adh.role && role_adh.code==null" 
                                            :required="role_adh.role">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="align-middle">
                                        Responsable  : 
                                    </td>
                                    <td class="align-middle">
                                        <input class="align-middle mr-2 ml-2" type="radio" id="one" :value="true" v-model="role_res.role"> <span :for="true" class="align-middle mr-2"> Oui </span>
                                        <input class="align-middle mr-2 ml-2" type="radio" id="two" :value="false" v-model="role_res.role"> <span :for="false" class=align-middle> Non </span>
                                    </td>
                                    

                                    <td class="align-middle" >
                                        <label>Sélectionnez le groupe à modifier : </label>
                                    </td>
                                    <td class="align-middle">
                                        <select class="form-control" v-model="group_selected" >
                                            <option disabled v-bind:value="-1" selected>Choisissez un groupe</option>
                                            <option  v-bind:value="null">aucun groupe</option>
                                            <option v-for="group in user_groups" v-bind:value="group.id" v-bind:key="group.id">
                                                {{group.name}}
                                            </option>
                                        </select>
                                    </td>

                                </tr>
                                <tr>
                                    <td  class="align-middle" colspan="4">
                                        <div class="text-center mt-4" >
                                            <b-button class="btn btn-default mr-3" :disabled="isBusy" @click="$emit('user-permission-done',null)">Annuler</b-button>
                                            <b-button variant="primary" disabled v-if="isBusy">
                                                <b-spinner small></b-spinner>
                                                Appliquer...
                                            </b-button>
                                            <b-button v-else type="submit" class="btn btn-primary"> Appliquer </b-button>
                                        </div>
                                    </td>
                                </tr>
                        </table>
                    </form>

    <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->

                    <div v-if="!_props.selected_user.password_exist" class="align-middle text-center align-middle">
                        <hr>
                        <div class="text-center mt-3" style="line-height: 2em;">
                            {{_props.selected_user.lastname}} {{_props.selected_user.firstname}} n'a pas encore finalisé la création de son compte.
                            <br>  Voulez-vous lui envoyer un e-mail avec le lien de création de mot de passe ?
                        </div>
                        <div>
                            <button @click="sendLink(_props.selected_user)" class="btn btn-info mt-4 "><i class="ti-email"></i>   </button>
                        </div>
                        
                    </div>
                </div>

            </div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  

        <b-modal  ref="permission_verifiy" centered hide-footer size="ml" v-if="_props.selected_user!=null" no-close-on-backdrop >            
            <template #modal-header="{}">
                <div class="text-center mt-3" style="line-height: 2em;" >
                    <span v-if="$store.getters.getProfile.id==selected_user.id"> En confirmant ce changement, vous serez supprimé de cette structure et vous serez déconnecté.</span>
                    <span v-else> En confirmant ce changement, vous supprimerez {{_props.selected_user.title}} {{_props.selected_user.lastname}}  {{_props.selected_user.firstname}}  de votre structure. </span>
                    
                         
                </div>
            </template>
            <template #default="{}">
                <div class="text-center mt-2" >
                    <button class="btn btn-default mr-3"  @click="$refs.permission_verifiy.hide()" :disabled="isBusy">Annuler</button>
                    <b-button variant="primary" disabled v-if="isBusy">
                        <b-spinner small></b-spinner>
                        Confirmer...
                    </b-button>
                    <b-button v-else @click="UpdateRole(2)" class="btn btn-primary"> Confirmer </b-button>
                </div>
            </template>
        </b-modal>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  
    </div>
</template>

<script>
    import api from "../config/_api";
    
    import {UPDATED_PROFILE} from '../store/actions/user';
    
    import {AUTH_LOGOUT} from '../store/actions/auth';
    
    import { mapGetters } from 'vuex';

export default {
    name :"UserPermission",
    data (){
        return {
            error : null,
            errormsg : "",
            isBusy : false,
            alert : {
                dismissSecs: 10,
                dismissCountDown: 0,
            },
            mailSent : null,
            role_adh : {
                id : 0,
                role : false,
                code : null,
                status : 0,
            },
            role_res : {
                id : 0,
                role :false,
                status : 0,
            },
            base_role_adh : {
                id : 0,
                role : false,
                code : null,
                status : 0,
            },
            base_role_res : {
                id : 0,
                role :false,
                status : 0,
            },
            status : 0,
            former_group: null,
            group_selected: -1,
        }
    },
    computed :{
        ...mapGetters({
                user_groups: 'user_groups/user_groups',
                structuresDistinct: 'adherents/structuresDistinct',
            }),
    },
    mounted() {
        this.$store.dispatch('user_groups/getGroups');
    },
    props :{
        selected_user: {
            type: Object,
            required: false
    }, 
    action : ""
    },
    created() {
        this.SetValue();
    },
    methods : { 
        SetValue(){
            if(this.selected_user!=null){
                for (var role of this.selected_user.structures){
                    if(role.id==this.$store.getters.structure_id)
                    {
                        if(role.pivot.role_id==1){
                            this.role_res.role=true;
                            this.role_res.id=role.pivot.id;
                            this.role_res.status=role.pivot.status;
                            this.base_role_res.role=true;
                            this.base_role_res.id=role.pivot.id;
                            this.base_role_res.status=role.pivot.status;
                        }

                        else if(role.pivot.role_id==3){
                            this.role_adh.role=true;
                            this.role_adh.id=role.pivot.id;
                            this.role_adh.code=role.pivot.code;
                            this.role_adh.status=role.pivot.status;
                            this.base_role_adh.role=true;
                            this.base_role_adh.id=role.pivot.id;
                            this.base_role_adh.code=role.pivot.code;
                            this.base_role_adh.status=role.pivot.status;
                        }
                    }
                }
                if(this.role_adh.role==false && this.role_res.role==false)
                {
                    this.status=1;
                }
                if(this.selected_user.user_groups.length > 0){
                    this.former_group = this.selected_user.user_groups[0].id;
                    this.group_selected = this.former_group;
                }
            }
        },
        sendLink(adh){
            
            this.email=adh.email;
            var data = {
                link : api.link ,
                email: this.email,
                type : 0
            };
            this.email=data.email;
            this.axios({url: api.url + 'password/create', data: data, method: 'POST' })
            .then(result => {
                this.mailSent=true;
            }, error => {
                this.mailSent=false;
            });
            this.showAlert();
            
        },            
        appliquer(){
            if(this.role_adh.role==false && this.role_res.role==false){
                this.$refs.permission_verifiy.show();
            }
            else{
                //Application du changement de rôle si besoin
                if(this.former_group != this.group_selected && this.group_selected!=-1){
                    // si aucun des groupes n'est selectionné 
                    var action = "assign/"+ this.group_selected;
                    if(this.group_selected == null){
                        //supprimer l'utilisateur du group
                        action = "unassign/"+ this.former_group;
                    }
                    
                    this.axios({url: api.url + 'users/' + this.selected_user.id + '/'+action + '?structure_id=' + this.$store.getters.structure_id, method: 'POST' })
                        .then(resp => {
                            if(resp.status < 400){
                               // this.$router.push("/usergroup/index");
                            }
                    })
                    .catch(err => {
                        this.error = true;
                        console.log(err);
                    });
                }
                if((this.base_role_adh.role != this.role_adh.role) || (this.base_role_adh.code != this.role_adh.code)  || (this.base_role_res.role != this.role_res.role)){
                    //Application du reste
                    this.UpdateRole(1);
                }
                else{
                    this.$emit('user-permission-done',null);
                }
            }
        },
        UpdateRole(event){
            this.isBusy=true;
            if(this.action=='add'){
                this.role_adh.status=1;
                this.role_res.status=1;
            }
            let user_has_roles = [
                { 
                    'id' : this.role_adh.id,
                    'role' :  this.role_adh.role,
                    'role_id' :3,
                    'code':  this.role_adh.code,
                    'status':this.role_adh.status,
                },
                {
                    'id' : this.role_res.id,
                    'role' :  this.role_res.role,
                    'role_id' :1,
                    'code':  null,
                    'status':this.role_res.status,
                }
            ];

            let data = {
                event : event,
                link: api.link,
                status : this.status,
                structure_id : this.$store.getters.structure_id,
                user_id : this.selected_user.id , 
                user_has_roles : user_has_roles,
            }
            this.axios({url: api.url + 'users/updateRole' , data: data, method: 'POST' })
                .then(resp => {
                    this.error = false;
                    this.$store.dispatch('adherents/getUtilisateurs');
                    
                    if(event==2){
                        this.$refs.permission_verifiy.hide();
                    }
                    if(this.$store.getters.getProfile.id==this.selected_user.id){
                        
                        this.axios({url: api.url + 'utilisateur/' + this.$store.getters.getProfile.id , data: null, method: 'POST' })
                            .then(resp => { 
                                this.$store.dispatch(UPDATED_PROFILE,resp.data.user).then(() => {
                                    var structIndex=this.$store.getters.getProfile.structures.findIndex(x => x.id === this.$store.getters.structure_id)
                                    if(structIndex==-1 || this.$store.getters.getProfile.structures[structIndex].pivot.role_id!=1){
                                        this.$store.dispatch(AUTH_LOGOUT).then(() => {
                                            this.$router.push('/login');
                                        });
                                    }
                                    else {
                                        this.$store.dispatch('adherents/getRoleInvitations');
                                        this.$store.dispatch('adherents/getStructuresDistinct');
                                        this.isBusy=false;
                                        this.showAlert();
                                        this.$emit('user-permission-done',{'error' : false,'event' : event});
                                    }
                                });
                            } ) ;
                    }
                    else{
                        this.isBusy=false;
                        this.showAlert(); 
                        this.$emit('user-permission-done',{'error' : false,'event' : event});
                    }
                        
                    
                })
                .catch(err => {
                    //console.log(err);
                    this.error = true;
                    //this.errormsg=err.response.data.message;
                    this.isBusy=false;
                    if(event==2){
                        this.$refs.permission_verifiy.hide();
                    }
                    this.$store.dispatch('adherents/getRoleInvitations');
                    this.$emit('user-permission-done',{'error' : true, 'errormsg' : this.errormsg,'event' : event});
                });
        },
        countDownChanged(dismissCountDown) {
            this.alert.dismissCountDown = dismissCountDown;
        },
        showAlert() {
            this.alert.dismissCountDown = this.alert.dismissSecs;
        },
    }
}
</script>
